import React, { useState } from "react";
import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE01003S = () => {

  const [isOpen, setIsOpen] = useState(false); // 드롭다운 메뉴 열림 상태
  const toggleDropdown = (e) => {
    e.preventDefault(); // 기본 동작 방지 (URL 변경 X)
    setIsOpen(!isOpen); // 상태 토글
  };

  return (
    <CommonLayout>
      <CommonMenu />
      <div id="contents" className="container">
        <div className="sub-title bg-type02">
          <h2>사업분야</h2>
        </div>

        <div className="location_wrap">
          <ul className="depth1">
            <li>
              <Link to="/">home</Link>
            </li>
            <li>
                <a href="#none" onClick={toggleDropdown}>
                    솔루션 제공<span></span>
                </a>
                <ul className="depth2" style={{ display: isOpen ? "block" : "none" }}>
                    <li>
                        <Link to="/GNBPURE01001S">시스템통합(SI)</Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01002S">시스템유지보수(SM)</Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01003S">솔루션 제공</Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01004S">
                            애플리케이션서비스 제공 (ASP)
                        </Link>
                    </li>
                    <li>
                        <Link to="/GNBPURE01005S">IT컨설팅 서비스</Link>
                    </li>
                </ul>
            </li>
          </ul>
        </div>

        <div id="cont" className="cont">
          <div className="inner">
            <h3>
              솔루션 제공
              <br />
              (Solution Offering)
            </h3>

            <article>
              <p className="subtitle">GNB & Pure 솔루션</p>
              <p>
                자사는 풍부한{" "}
                <strong>
                  SI/SM 인력들의 현장 경험과 R&D 및 ASP를 담당하는 연구소
                  인력들의 기술적 지식
                </strong>
                을 바탕으로 고객사의 요구에 최적화된 맞춤 솔루션을
                제공합니다.
                <br />
                자사는 금융시스템 개발에 필요한 프레임워크, UI솔루션, 대외계 및
                채널통합솔루션, 모바일푸시솔루션을 제공합니다. 또한,{" "}
                <strong style={{ color: "red", fontWeight: "bold" }}>
                  금융업무에 필요한 솔루션(대출시스템, 무수익채권(NPL) 관리
                  시스템, 주식매입자금대출(스탁론) 시스템, 펌뱅킹,
                  스마트뱅킹시스템)을 제공
                </strong>
                합니다.
              </p>
            </article>

            <article>
              <p className="subtitle">DFINS(돌핀 금융정보 솔루션)</p>
              <img src="/asset/img/subB/img_solution_all.png" alt="저작권1" className="vis_img pc" />
              <img src="/asset/img/subB/img_solution_all.png" alt="저작권1" className="mo" />
            </article>

            <article>
              <p className="subtitle">GNB & Pure S/W 저작권</p>
              <img src="/asset/img/subB/dfins1.png" alt="저작권1" className="vis_img pc" />
              <img src="/asset/img/subB/dfins2.png" alt="저작권2" className="vis_img pc" />
              <img src="/asset/img/subB/dfins1.png" alt="저작권1" className="mo" />
              <img src="/asset/img/subB/dfins2.png" alt="저작권2" className="mo" />
            </article>
          </div>
        </div>
      </div>
      <CommonFooter />
    </CommonLayout>
  );
};

export default GNBPURE01003S;